import countries from "../../../utils/constants";

function AddEnterpriseForm({
  formData,
  onInputChange,
  onSelectChange,
  submittedForm,
  enterpriseResponse
}) {
  const handleEnterpriseSubmit = () => {
  };

  return (
    <form>
      <div
        className="form-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "20px",
        }}
      >
        <div className="mb-3">
          <label className="form-label required ">Enterprise Name</label>
          <input
            type="text"
            name="name"
            className="form-control form-control-solid"
            placeholder={submittedForm ? formData.name : "Enter Enterprise Name"}
            value={submittedForm ? "" : formData.name}
            onChange={onInputChange}
            disabled={submittedForm}
          />
        </div>
        <div className="mb-3">
          <label className="form-label required">
            Enterprise Email
          </label>

          <input
            type="text"
            name="email"
            className="form-control form-control-solid"
            placeholder={submittedForm ? formData.email : "name@example.com"}
            value={submittedForm ? "" : formData.email}
            onChange={onInputChange}
            disabled={submittedForm}
          />
        </div>

        <div className="mb-3">
          <label className="form-label required">Country</label>
          {submittedForm ? (
            <input
              type="text"
              name="country"
              className="form-control form-control-solid"
              placeholder={formData.country}
              disabled
            />
          ) : (
            <select
              className="form-select form-select-solid"
              value={formData.country}
              onChange={(event) => onSelectChange("country", event.target.value)}
            >
              <option value="" disabled>
                Select Country
              </option>
              {countries.map((country) => (
                <option key={country.code} value={country.name}>
                  {country.flag} {country.name}
                </option>
              ))}
            </select>
          )}
        </div>
        <div className="mb-3">
          <label className="form-label required">Website</label>
          <input
            type="text"
            name="site"
            className="form-control form-control-solid"
            placeholder={submittedForm ? formData.site : "example.com"}
            value={submittedForm ? "" : formData.site}
            onChange={onInputChange}
            disabled={submittedForm}
          />
        </div>
        <div className="mb-0.5">
          <label className="form-label required">Phone</label>
          <input
            type="text"
            name="ph"
            className="form-control form-control-solid"
            placeholder={submittedForm ? formData.ph : "Enter Phone Number"}
            value={submittedForm ? "" : formData.ph}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                onInputChange(e);
              }
            }}
            disabled={submittedForm}
          />
        </div>

        {/* Contract Details */}
        {/* <div className='mb-3'>
          <label className='form-label required'>Contract Start Date</label>
          <input
            type={submittedForm ? 'text' : 'date'}
            name='contract_start_date'
            className='form-control form-control-solid'
            value={submittedForm ? '' : formData.contract_start_date}
            placeholder={submittedForm ? formData.contract_start_date : ''}
            onChange={onInputChange}
            disabled={submittedForm}
          />
        </div>

        <div className='mb-3'>
          <label className='form-label required'>Contract Duration (months)</label>
          <input
            type='number'
            name='contract_duration_months'
            className='form-control form-control-solid'
            placeholder={submittedForm ? String(formData.contract_duration_months) : 'e.g. 12'}
            value={submittedForm ? '' : formData.contract_duration_months}
            onChange={onInputChange}
            disabled={submittedForm}
            min={1}
          />
        </div> */}

        {/* <div className="mb-0.5">
          {submittedForm && ( 
            <>
          <label className="form-label required">Unit</label>

            <input
              type="text"
              name="unit"
              className="form-control form-control-solid"
              placeholder={formData.unit}
              disabled
            />
            </>
          )
           : (
            <select
              className="form-select form-select-solid"
              value={formData.unit}
              onChange={(event) => onSelectChange("unit", event.target.value)}
            >
              <option value="" disabled>
                Select an option
              </option>
              {unitoptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )
          }
        </div> */}
        {submittedForm && (
          <>

            <div className="mb-5">
              <label className="form-label">Password</label>
              <input
                type="text"
                name="password"
                className="form-control form-control-solid"
                placeholder={enterpriseResponse.password}
                disabled
              />
            </div>
            <div className="mb-5">
              <label className="form-label">Enterprise ID</label>
              <input
                type="text"
                name="enterprise_id"
                className="form-control form-control-solid"
                placeholder={enterpriseResponse.id}
                disabled
              />
            </div>

            <div className='mb-5'>
              <label className='form-label'>Contract End Date</label>
              <input
                type='text'
                className='form-control form-control-solid'
                placeholder={enterpriseResponse?.contract_end_date}
                disabled
              />
            </div>
          </>
        )}

      </div>
      <button type="submit" className="d-none" onClick={handleEnterpriseSubmit}>
        Submit
      </button>
    </form>

  );
}

export default AddEnterpriseForm;
